import { Component, Input, ViewChild, ElementRef, AfterViewInit, Output, EventEmitter, OnInit, Renderer2 } from '@angular/core';
import { Column } from '../../shared/interfaces/rms-interfaces';
import { WebService } from '../../services/web.service';
import { RmsModule } from '../../custom-modules/rms-module/rms.module';
import { lastValueFrom } from 'rxjs';

@Component({
  selector: 'app-purchase-confirmation',
  templateUrl: './purchase-order-confirm.component.html',
  styleUrls: ['./purchase-order-confirm.component.scss'],
  imports: [RmsModule]
})
export class PurchaseOrderConfirmComponent implements OnInit {
  @Input() supplier: string = '';
  @Input() purchaseDate: string = '';
  @Input() intermediary: string = '';
  @Input() priceTerms: string = '';
  @Input() coffeeDescription: string = '';
  @Input() marksNo: string = '';
  @Input() bags: number = 0;
  @Input() priceRef: string = '';
  @Input() finalDifferential: string = '';
  @Input() notes: string = '';
  @Input() data: any;

  PurchaseOrder: any | null = null 


  @Output() htmlGenerated: EventEmitter<string> = new EventEmitter<string>();

  @ViewChild('reportContent', { static: false }) reportContent!: ElementRef;

  InventoryColumns: Column[] = [
    { label: 'Ref #', key: 'InventoryID', width: 5 },
    { label: 'Supplier Ref #', key: 'SupplierReffNumber', width: 10 },
    { label: 'Inventory Name', key: 'InventoryTypeName', width: 25 },
    { label: 'Marks', key: 'Marks', width: 10 },
    { label: 'SAS', key: 'SampleApprovalTerm', width: 20 },
    { label: 'Bags Purchased', key: 'BagsOrdered', width: 10 },
    { label: 'Price', key: 'Price', width: 20 },
  ]

  constructor(private render: Renderer2, private web: WebService) { }

  async ngOnInit() {
    this.PurchaseOrder = await lastValueFrom(this.web.getWebCall('inventory', 'coffee/inventory/purchase-order-for-confirm', { params: [{ value: this.data.PurchaseOrderID, name: 'PurchaseOrderID' }] }))
    this.PurchaseOrder = this.PurchaseOrder[0];
    this.PurchaseOrder.Inventory = JSON.parse(this.PurchaseOrder.Inventory);
    console.log(this.PurchaseOrder);
  }

  getHtml() {
    return this.reportContent.nativeElement.innerHTML; // Get the HTML of the report content
  }
}
